import { useState } from "react";
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";
import SvgIcon from "../../../../../Utils/CommonComponents/CommonIcons/CommonSvgIcons";

const ChatDropMenu = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prevState) => !prevState);
  return (
    <Dropdown isOpen={dropdownOpen} toggle={toggle} direction="up" className="p-0">
      <DropdownToggle color="transparent" className="dropdown-form border-0">
        <i className="icon-plus text-dark-emphasis" />
      </DropdownToggle>
      <DropdownMenu className="chat-icon">
        <DropdownItem tag='div' className="mb-2">
          <SvgIcon iconId="camera" />
        </DropdownItem>
        <DropdownItem tag='div'>
          <SvgIcon iconId="attchment" />
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
};

export default ChatDropMenu;
